<template>
  <customModal :containermd="true" @closeModal="$emit('closeModal')">
    <template #title>
      {{ modalTitle }}
    </template>

    <template #body>
      <!-- Thresholds -->
      <div v-if="type === 'thresholds'">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Min</th>
              <th>Max</th>
              <th>Probability</th>
              <th>Impact</th>
              <th>Detectability</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(t, i) in thresholdsData" :key="i">
              <td>{{ t.min }}</td>
              <td>{{ t.max }}</td>
              <td>{{ t.probability }}</td>
              <td>{{ t.impact }}</td>
              <td>{{ t.detectibility }}</td>
            </tr>
            <tr v-if="!thresholdsData.length">
              <td colspan="5" class="text-center text-muted">No thresholds</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Risk Levels -->
      <div v-if="type === 'riskLevels'">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Min Score</th>
              <th>Max Score</th>
              <th>Label</th>
              <th>Color</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, i) in riskLevelsData" :key="i">
              <td>{{ r.scoreRange.min }}</td>
              <td>{{ r.scoreRange.max }}</td>
              <td>{{ r.label }}</td>
              <td>
                <span
                  :style="{
                    background: r.color,
                    color: '#fff',
                    padding: '2px 8px',
                    borderRadius: '4px'
                  }"
                >
                  {{ r.color }}
                </span>
              </td>
            </tr>
            <tr v-if="!riskLevelsData.length">
              <td colspan="4" class="text-center text-muted">No risk levels</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Critical Data Points -->
      <div v-if="type === 'criticalDataPoints'">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>eCRF</th>
              <th>Field Names</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(c, i) in criticalDataPointsData" :key="i">
              <td>{{ c.templateName }}</td>
              <td>
                <span v-if="Array.isArray(c.fieldnames) && c.fieldnames.length">
                  {{ c.fieldnames.join(', ') }}
                </span>
              </td>
            </tr>
            <tr v-if="!criticalDataPointsData.length">
              <td colspan="2" class="text-center text-muted">No data found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </customModal>
</template>
<script src="./RbqmThresholdViewModal.js"></script>
